import {getSetting} from '@dvrd/dvr-controls';
import {DefaultFetch, ResponseData} from '@dvrd/fetch';
import {WaitlistDay} from '../enums';
import {DEVICE_ID} from './startup';

interface WithData<T> {
    data: T;
}

type Callback = { callback: (data: ResponseData, response: Response) => void };

const requestSender = new DefaultFetch(
    {baseURL: getSetting('platformURL'), credentials: 'include', headers: {'X-Device-Id': DEVICE_ID}});

export function getUser(params: Callback) {
    return requestSender.get({url: '/auth/user', ...params});
}

export function updateUser(params: WithData<any> & Callback) {
    //TODO
}

export function deleteUser(params: Callback) {

}

interface LoginData {
    email: string;
    password: string;
}

export function login(params: WithData<LoginData> & Callback) {
    return requestSender.post({url: '/auth/login', ...params});
}

interface CreateWaitlistEntry {
    days: Array<WaitlistDay>;
    customer_name: string | null;
    dog_name: string | null;
    tel: string | null;
    email: string | null;
    comment: string | null;
}

interface WithEntryID {
    entry_id: string;
}

type UpdateWaitlistEntry = Partial<CreateWaitlistEntry> & WithEntryID & { index?: number };

interface PatchWaitlistEntries {
    entries: Array<UpdateWaitlistEntry>;
}

export function getWaitlistEntries(params: Callback) {
    return requestSender.get({url: '/waitlist-entry/get-entries', ...params});
}

export function createWaitlistEntry(params: WithData<CreateWaitlistEntry> & Callback) {
    return requestSender.post({url: '/waitlist-entry/add-entry', ...params});
}

export function updateWaitlistEntry(params: WithData<UpdateWaitlistEntry> & Callback) {
    return requestSender.put({url: '/waitlist-entry/update-entry', ...params});
}

export function patchWaitlistEntries(params: WithData<PatchWaitlistEntries> & Callback) {
    return requestSender.patch({url: '/waitlist-entry/patch-entries', ...params});
}